import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeColor, Copy, Flex, Currency } from '@elparking/components'

import { FormattedMessage } from 'react-intl'

export const ContainerOldPrice = styled.div`
    position: relative;
    &:after{
        content: '';
        position:absolute;
        left: 0;
        bottom: 0;
        border-top: 3px solid ${themeColor('accent')};
        width:100%;
        transform: rotate(345deg);
        transform-origin: 0% 0%;
    }
`

const PriceContainer = ({
    totalPrice,
    originalPrice,
    color,
}) => (
    <Flex
      w='auto'
      justifyContent='start'
      alignItems='center'
    >
        <Copy padding='0' textAlign='center' color={color} fontWeight='medium' transform='uppercase' fontSize='large'>
            <Currency qty={totalPrice} />
        </Copy>
        {originalPrice && <Flex flexDirection='column' pl='8px'>
            <Copy padding='0' textAlign='center' color={color} fontWeight='regular' transform='uppercase' fontSize='xxxSmall'>
                <FormattedMessage defaultMessage='Antes' />
            </Copy>
            <Copy lineHeight='0.8em' padding='0' textAlign='center' color={color} fontWeight='book' transform='uppercase' fontSize='small'>
                <ContainerOldPrice>
                    <Currency qty={originalPrice} />
                </ContainerOldPrice>
            </Copy>
        </Flex>
        }
    </Flex>
)

PriceContainer.defaultProps = {
    color: 'gray80',
}

PriceContainer.propTypes = {
    originalPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    totalPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }).isRequired,
    color: PropTypes.string,
}

export default PriceContainer
